import { Component, Input } from '@angular/core';
import { SceneLoadProgressEvent } from 'noodle/engine/scene/SceneLoadProgress';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.html',
  styleUrl: './loading-overlay.css',
})
export class LoadingOverlay {
  @Input({ required: true }) progress!: SceneLoadProgressEvent;
}
